module.exports = __webpack_public_path__ + "img/authorized-devices.c0f03abe.svg";